import styled from "styled-components";

const Styles = styled.div`
  /* 이벤트 관리 - 테이블 - new row */
  .row-new td {
    background: #feefef !important;
  }

  /* 이벤트 상황 조회 (팝업) */
  .eventModal {
    max-width: 1000px;
    max-height: 800px;
    & .status-container {
      width: fit-content;
      height: fit-content;
      max-height: 546px;
      overflow-y: scroll;
    }
  }
  .event-info {
    font-size: 16px;
    margin-bottom: 12px;
  }

  /* 디바이스 상태 관리 - 테이블 - 통신상태 : 오류/정상*/
  .status-error,
  .status-normal {
    &::before {
      content: "";
      width: 11px;
      height: 11px;
      border-radius: 50%;
      margin-right: 8px;
      display: inline-block;
    }
  }
  .status-error::before {
    background: #ef5d5d;
  }
  .status-normal::before {
    background: #1a65bc;
  }

  & .tree-noexpand {
    & .ant-tree-switcher {
      display: none;
    }
  }

  .rpc-head-container {
    @media all and (max-width: 479px) {
      width: 100%;

      & .rpc-head-inline {
        display: flex;
        justify-content: space-between;

        .ant-space-item {
          width: inherit;
        }
      }

      & .ant-radio-group.rpc-head-inline {
        label:first-child:nth-last-child(1) {
          width: 100%;
        }
        label:first-child:nth-last-child(2),
        label:first-child:nth-last-child(2) ~ label {
          width: 50%;
        }
        label:first-child:nth-last-child(3),
        label:first-child:nth-last-child(3) ~ label {
          width: 33.3333%;
        }
        label:first-child:nth-last-child(4),
        label:first-child:nth-last-child(4) ~ label {
          width: 25%;
        }
      }

      & .ant-space-item {
        width: 100%;
      }

      & .rpc-head-item {
        width: 100%;
      }

      & .rpc-head-button {
        width: 134px;
      }
    }
  }
  .rpc-head-space.rpc-pc {
    @media all and (max-width: 767px) {
      display: none;
    }
  }

  .rpc-head-space.rpc-mobile {
    @media all and (min-width: 767px) {
      display: none;
    }
  }
`;

export default Styles;
